var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.userProfile.data().userRole).toLowerCase() === 'admin' || (_vm.userProfile.data().userRole).toLowerCase() === 'super admin')?_c('adminHome'):_c('generalHome')}
var staticRenderFns = []

export { render, staticRenderFns }